export function buildQueryParams(obj) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value !== 'undefined' && value !== null) {
      // Handle arrays and objects recursively (optional)
      if (Array.isArray(value) || typeof value === 'object') {
        for (const item of value) {
          params.append(key, item); // Handle array values
        }
      } else {
        params.append(key, value);
      }
    }
  }
  return params;
}
